// extracted by mini-css-extract-plugin
export var calendarView = "_ka-0";